import { useContext } from 'react';

import { HoneycombExtentConfig } from '../context/honeycomb-extent-config.context.js';

export const useHoneycombExtent = () => useContext(HoneycombExtentConfig);
